import { Controller } from 'stimulus';

export default class BodyController extends Controller {
  static values = {
    letterType: Number,
    letterTypeLabel: String
  }

  static targets = ['firstStep', 'letterTime', 'letterTimeLabel', 'letter', 'trimmable', 'notes', 'timer']

  connect() {
    this.startTimer();
  }

  startTimer() {
    let seconds = 0;

    setInterval(() => {
      this.timerTarget.innerHTML = seconds;
      seconds++;
    }, 1000)
  }

  changeLetterType(event) {
    const letterType = event.currentTarget.dataset.letterType;
    this.letterTypeLabelValue = event.currentTarget.innerHTML;

    if (letterType == 1) { this.letterTypeValue = 1; }
    else if (letterType == 2) { this.letterTypeValue = 2; } 
    else if (letterType == 3) { this.letterTypeValue = 3; } 
    else { this.letterTypeValue = null }
  }

  letterTypeLabelValueChanged() {
    this.letterTimeLabelTarget.innerHTML = this.letterTypeLabelValue;
  }
  
  letterTypeValueChanged() {
    if(!this.letterTypeValue) this.showletterTypeQuestion();
    if(this.letterTypeValue == 1) this.showSimpleApplication();
    if(this.letterTypeValue == 2) this.showNormalApplication();
    if(this.letterTypeValue == 3) this.showExtendedApplication();
  }

  showletterTypeQuestion() {
    this.firstStepTarget.classList.remove('hidden');
    this.letterTimeTarget.classList.add('hidden');
    this.letterTarget.classList.add('hidden');
    this.trimmableTargets.forEach(notes => notes.classList.add('hidden'));  
    this.notesTargets.forEach(notes => notes.classList.remove('hidden'));  
  }

  showSimpleApplication() {
    this.firstStepTarget.classList.add('hidden');
    this.letterTimeTarget.classList.remove('hidden');
    this.letterTarget.classList.remove('hidden');
    this.trimmableTargets.forEach(notes => notes.classList.add('hidden'));  
    this.notesTargets.forEach(notes => notes.classList.add('hidden'));  
  }

  showNormalApplication() {
    this.firstStepTarget.classList.add('hidden');
    this.letterTimeTarget.classList.remove('hidden');
    this.letterTarget.classList.remove('hidden');  
    this.trimmableTargets.forEach(notes => notes.classList.remove('hidden'));  
    this.notesTargets.forEach(notes => notes.classList.add('hidden'));  
  }

  showExtendedApplication() {
    this.firstStepTarget.classList.add('hidden');
    this.letterTimeTarget.classList.remove('hidden');
    this.letterTarget.classList.remove('hidden');  
    this.trimmableTargets.forEach(notes => notes.classList.remove('hidden'));  
    this.notesTargets.forEach(notes => notes.classList.remove('hidden'));  
  }
}